module.exports = __webpack_public_path__ + "3039dcdae0adb1e7f20c349062a76fef.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-banner-cinderalla.svg
// module id = 467
// module chunks = 0